import { render, staticRenderFns } from "./ProfileRenderer.vue?vue&type=template&id=7b3087da&scoped=true&"
import script from "./ProfileRenderer.vue?vue&type=script&lang=js&"
export * from "./ProfileRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3087da",
  null
  
)

export default component.exports